import { TaggedNumberInput, TaggedSelect, TaggedTextInput } from '@components/inputs';
import TaggedRadio from '@components/inputs/TaggedRadio';
import TaggedModal from '@components/TaggedModal';
import { useCreateGradingLimit } from '@modules/gradingLimits/src/gradingLimitsMutations';
import { Descriptions, Form } from 'antd';
import { FC } from 'react';

interface AddGradingLimitsModalProp {
  closeModal: () => void;
  showModal: boolean;
  themes: Inputs.SelectOption[];
}

const AddGradingLimitsModal: FC<AddGradingLimitsModalProp> = (props) => {
  const { closeModal, showModal, themes } = props;

  const { mutate, isLoading } = useCreateGradingLimit(closeModal);

  const onSubmit = (values: GradingLimits.CreateGradingLimitPayload) => {
    mutate(values);
  };

  return (
    <TaggedModal
      tag="addGradingLimits"
      title="Add Grading Limits"
      centered
      destroyOnHidden
      open={showModal}
      okText="Submit"
      okButtonProps={{ htmlType: 'submit', form: 'addGradingLimitsForm', loading: isLoading }}
      onCancel={closeModal}
      width="30%"
    >
      <Descriptions labelStyle={{ fontWeight: 'bold' }} title="New Grade" />
      <Form id="addGradingLimitsForm" onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="grade"
          label="Grade:"
          rules={[
            {
              required: true,
              message: 'Please fill here.',
            },
          ]}
        >
          <TaggedTextInput width="10%" tag="grade" />
        </Form.Item>
        <Form.Item
          name="suggestedAbsoluteLimit"
          label="Suggested Absolute Limit:"
          rules={[
            {
              required: true,
              message: 'Please fill here.',
            },
          ]}
        >
          <TaggedNumberInput width="10%" tag="suggestedAbsoluteLimit" />
        </Form.Item>
        <Form.Item
          name="suggestedLimitPercentage"
          label="Suggested % Limit:"
          rules={[
            {
              required: true,
              message: 'Please fill here.',
            },
          ]}
        >
          <TaggedNumberInput width="10%" tag="suggestedLimitPercentage" />
        </Form.Item>
        <Form.Item label="Theme:" name="suggestedThemeId" rules={[{ required: true, message: 'Please select a theme.' }]}>
          <TaggedSelect tag="selectTheme" options={themes || []} placeholder="Choose a theme." />
        </Form.Item>
        <Form.Item label="Active:" name="activeStatus" initialValue={1} required rules={[{ required: true, message: 'Please select a status.' }]}>
          <TaggedRadio
            tag="transactionType"
            options={[
              { value: 1, label: 'Active' },
              { value: 0, label: 'Inactive' },
            ]}
          />
        </Form.Item>
      </Form>
    </TaggedModal>
  );
};

export default AddGradingLimitsModal;
